import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import * as $ from 'jquery';
import {ActivatedRoute, Router} from '@angular/router';
import DROPDOWN_TYPES from "../../enums/dropdownTypes.enum";
import IFilter from "../../interfaces/IFilter";
import QueryParams from "../../services/queryParams.service";

@Component({
    selector: 'dropdown',
    template: require('./dropdown.component.html'),
    styles: [String(require('./dropdown.styl'))],
})

export class DropdownComponent {

    @Input() private filter: IFilter;
    @Input() private type: DROPDOWN_TYPES = DROPDOWN_TYPES.TOP;
    @Input() private autoUpdateQueryParams: boolean = true;
    @Output() private elementSelected = new EventEmitter();

    constructor(private element: ElementRef,
                private activatedRoute: ActivatedRoute,
                private queryParams: QueryParams) {

    }

    ngAfterViewInit() {
        let selectpicker = $(this.element.nativeElement)['find']('.selectpicker');
        selectpicker['selectpicker']('render');
        this.activatedRoute.queryParams.subscribe((queryParams) => {
            if (queryParams[this.filter.name]) {
                selectpicker['selectpicker']('val', queryParams[this.filter.name]);
            } else {
                selectpicker['selectpicker']('val', this.filter.options[0]);
            }
        })
        selectpicker.on('changed.bs.select', (e, clickedIndex) => {
            this.elementSelected.emit(this.filter.options[clickedIndex]);
            if (this.autoUpdateQueryParams)
                this.queryParams.update({
                    [this.filter.name]: this.filter.options[clickedIndex]
                }, this.activatedRoute);
        })

    }

}



// WEBPACK FOOTER //
// ./src/app/components/dropdown/dropdown.component.ts